<template>
  <b-row v-if="parentPath && path" style="margin-bottom:30px">
    <b-col md="12">
      <!--  :header="uniTranslation('S876')" -->
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.numberOfPlates'"
              :fixed-decimals="0"
              :validate-usr-value="true"
            ></UnidataEditor>
          </div>
          <div class="col-xl-6 col-lg-12">
            <b v-if="isCalculated()"> {{ stringa_PED() }}</b>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div class="unidata-editor">
              <div class="row mr-0">
                <div class="col-6">
                  <label
                    v-if="highPerformancePlatePercentageVisible"
                    v-tooltip="uniToolTipTranslation('PHE569', 'en-US')"
                    class="label-unidato"
                  >
                    {{ uniTranslation("PHE569") }}
                  </label>
                </div>
                <div class="unidata-item-container col-2"></div>
                <div class="col-4">
                  <div class="row">
                    <div class="unidata-item-container col-12">
                      <el-select
                        v-if="highPerformancePlatePercentageVisible"
                        v-model="highPerformancePlatePercentageValue"
                        class="pheShoulderSelect"
                        placeholder="Select"
                        @change="/*setProjecthighPerformancePlatePercentageValue()*/"
                      >
                        <el-option
                          v-for="item in highPerformancePlatePercentage"
                          :key="item"
                          :label="uniTranslation(item)"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12">
            <p>&nbsp;</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.numberOfCircuitsPrimarySide'"
              :fixed-decimals="0"
              :validate-usr-value="true"
            ></UnidataEditor>
          </div>
          <div class="col-xl-6 col-lg-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.numberOfCircuitsSecondarySide'"
              :fixed-decimals="0"
              :validate-usr-value="true"
            ></UnidataEditor>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
// import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
import UnidataEditor from "../unidata/UnidataEditor";
//import { Select, Option, Collapse, CollapseItem } from "element-ui";
import { /*Radio,*/ Select, Option, Collapse, CollapseItem } from "element-ui";
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
import geometryPHEServiceCipriani from "../../services/backend/geometryPHEServiceCipriani";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    // UnidataEditorCorrelator,
    UnidataEditor,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
    // projectModality:{
    //   type: Number,
    //   required: true
    // },
    // projectType:{
    //   type: String,
    //   required: true
    // }
  },
  data() {
    return {
      path: null,
      calculationType: "",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      highPerformancePlatePercentageValue: 0,
      highPerformancePlatePercentageVisible: false,
      modality: 8,
      unsubscribes: [],
      catPED: ""
    };
  },
  computed: {
    ...mapGetters(["projects"])
  },
  asyncComputed: {
    highPerformancePlatePercentage: async function() {
      if (this.modality) {
        let list = null;
        let that = this;

        // alert("sono qui 1");

        var fromSelezione =
          that.$store.getters.calcStep == "POST CALCOLO SELEZIONE" ||
          that.$store.getters.calcStep == "POST CALCOLO VERIFICA" ||
          that.$store.getters.calcStatus.includes("ARRIVO_DA_SELEZIONE") == true;

        await geometryPHEServiceCipriani
          .getHighPerformancePlatePercentageValues(that.modality)
          .then(function(data) {
            list = data;
            if (list && list.length > 0) {
              // alert("sono qui 2");

              if (fromSelezione == true) {
                // Siamo nel calcolo di verifica di un risultato della griglia di selezione
                // Il BACK-END ha già impostato il valore
                that.highPerformancePlatePercentageValue = jsonHelper.getProperty(
                  that.projects,
                  that.parentPath + ".bottom.highPerformancePlatePercentageValue"
                );
              } else that.highPerformancePlatePercentageValue = list[0];
            }
          });

        //this.setProjecthighPerformancePlatePercentageValue();

        return list;
      }
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    highPerformancePlatePercentageValue: function(nv, ov) {
      if (nv !== undefined && nv !== null) {
        var that = this;
        this.$store.dispatch("changeProjectProperty", {
          path: that.path + ".highPerformancePlatePercentageValue",
          value: that.highPerformancePlatePercentageValue
        });
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }

    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "changeTypeOfPheChannel") {
        that.updateHigPerformacePlatePercentageVisible();
      }
    });

    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "refreshAll") {
        var calculated = jsonHelper.getProperty(that.projects, that.parentPath + ".calculated");
        if (calculated) {
          that.catPED = that.stringa_PED();
        } else {
          that.catPED = "";
        }

        that.highPerformancePlatePercentageValue = jsonHelper.getProperty(
          that.projects,
          that.parentPath + ".bottom.highPerformancePlatePercentageValue"
        );
      }
    });

    that.modality = jsonHelper.getProperty(that.projects, that.parentPath + ".modality");

    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important";
    that.coloreTesto = colorList[2];
    that.coloreBordo = colorList[6];
    //});

    if (this.$store.getters.profiloUtente) {
      if (!this.$store.getters.profiloUtente.circuitFree) {
        this.settaCircuitiLocked();
      }
    }
  },

  methods: {
    isCalculated(){
      return jsonHelper.getProperty(this.projects, this.parentPath + ".calculated");
    },
    async updateHigPerformacePlatePercentageVisible() {
      var that = this;

      var id = that.$store.getters.typeOfPheChannel;

      await geometryPHEServiceCipriani.getPlateChannelTypeCodeById(id).then(function(data) {
        if (data === "M") {
          that.highPerformancePlatePercentageVisible = true;
        } else {
          that.highPerformancePlatePercentageVisible = false;
        }
      });
    },

    setProjecthighPerformancePlatePercentageValue() {},

    settaCircuitiLocked() {
      var updating = false;
      var that = this;
      that.unsubscribes.push(
        that.$store.subscribe(function(mutation) {
          if (!updating && mutation.type === "changeProjectProperty") {
            var newVal = mutation.payload.value;
            if (newVal !== "") {
              if (mutation.payload.path.indexOf(that.path + ".numberOfCircuitsPrimarySide") >= 0) {
                updating = true;
                that.settaValore("bottom.numberOfCircuitsSecondarySide", newVal, true, true, true);
                updating = false;
              }
              if (
                mutation.payload.path.indexOf(that.path + ".numberOfCircuitsSecondarySide") >= 0
              ) {
                updating = true;
                that.settaValore("bottom.numberOfCircuitsPrimarySide", newVal, true, true, true);
                updating = false;
              }
            }
          }
        })
      );
    },

    settaValoreUM(elementoUM, valore) {
      // var that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: elementoUM,
        value: valore
      });
    },

    settaValore(elemento, valore, input, output, bilancio) {
      var el = this.parentPath + "." + elemento;
      if (input) {
        this.settaValoreUM(el + ".input.refValue.value", valore);
        this.settaValoreUM(el + ".input.usrValue.value", valore);
      }
      if (output) {
        this.settaValoreUM(el + ".output.refValue.value", valore);
        this.settaValoreUM(el + ".output.usrValue.value", valore);
      }
      if (bilancio) {
        this.settaValoreUM(el + ".outputBilancio.refValue.value", valore);
        this.settaValoreUM(el + ".outputBilancio.usrValue.value", valore);
      }
      this.$store.dispatch("refreshAll");
    },

    stringa_PED() {
      var strPED;
      var innerP = jsonHelper.getProperty(this.projects, this.parentPath + ".innerProject");
      if (innerP.ciprianI_bControllo_PED) {
        strPED = this.uniTranslation("PHE10213") + " "; // GetT(10213, "PED :") & " " & Str

        if (innerP.ciprianI_CategoriaPED == "-") {
          strPED += this.uniTranslation("PHE10055"); //GetT(10055, "Esente art. 3.3")
        } else {
          strPED += innerP.ciprianI_CategoriaPED;
        }
      } else {
        strPED = "";
      }

      return strPED;
    }
  }
};
</script>

<style lang="scss">
$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}

.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
</style>
